module.exports = __webpack_public_path__ + "img/Hypoxia-OSCC_GSE208253.83eb6282.png";